import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ab8bf5d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-boldest m-0" }
const _hoisted_5 = { class: "card-body p-9" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = { class: "form-group d-flex flex-wrap" }
const _hoisted_9 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_10 = { class: "el-form-item__content" }
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "form-group d-flex flex-wrap" }
const _hoisted_13 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "form-group d-flex flex-wrap" }
const _hoisted_16 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "form-group d-flex flex-wrap" }
const _hoisted_19 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = { class: "form-group d-flex flex-wrap" }
const _hoisted_22 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_23 = { class: "col-md-6" }
const _hoisted_24 = { class: "form-group d-flex flex-wrap" }
const _hoisted_25 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_26 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1))
const _hoisted_28 = {
  key: 0,
  type: "submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_29 = { class: "indicator-label" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 size" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "bi bi-sd-card-fill"
  })
], -1))
const _hoisted_31 = { class: "indicator-progress" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_33 = { class: "card mb-5 mb-xl-10" }
const _hoisted_34 = { class: "card-header" }
const _hoisted_35 = { class: "card-title m-0" }
const _hoisted_36 = { class: "fw-boldest m-0" }
const _hoisted_37 = { class: "card-body p-9" }
const _hoisted_38 = { class: "row" }
const _hoisted_39 = { class: "col-md-6" }
const _hoisted_40 = { class: "form-group d-flex flex-wrap" }
const _hoisted_41 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_42 = { class: "col-md-6" }
const _hoisted_43 = { class: "form-group d-flex flex-wrap" }
const _hoisted_44 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_45 = { class: "col-md-6" }
const _hoisted_46 = { class: "form-group d-flex flex-wrap" }
const _hoisted_47 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_48 = { class: "col-md-6" }
const _hoisted_49 = { class: "form-group d-flex flex-wrap" }
const _hoisted_50 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_51 = { class: "col-md-6" }
const _hoisted_52 = { class: "form-group d-flex flex-wrap" }
const _hoisted_53 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_54 = { class: "d-flex el-input el-input-group el-input-group--append el-input--suffix" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-input-group__append d-flex w-auto flex-center" }, " EUR ", -1))
const _hoisted_56 = { class: "col-md-6" }
const _hoisted_57 = { class: "form-group d-flex flex-wrap" }
const _hoisted_58 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_59 = { class: "col-md-6" }
const _hoisted_60 = { class: "form-group d-flex flex-wrap" }
const _hoisted_61 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_62 = { class: "col-md-6" }
const _hoisted_63 = { class: "form-group d-flex flex-wrap" }
const _hoisted_64 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_65 = { class: "col-md-6" }
const _hoisted_66 = { class: "form-group d-flex flex-wrap" }
const _hoisted_67 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_68 = { class: "col-md-6" }
const _hoisted_69 = { class: "form-group d-flex flex-wrap" }
const _hoisted_70 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_71 = { class: "col-md-6" }
const _hoisted_72 = { class: "form-group d-flex flex-wrap" }
const _hoisted_73 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator mb-7" }, null, -1))
const _hoisted_75 = { class: "col-md-6" }
const _hoisted_76 = { class: "form-group d-flex flex-wrap" }
const _hoisted_77 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_78 = ["disabled"]
const _hoisted_79 = ["disabled"]
const _hoisted_80 = ["disabled"]
const _hoisted_81 = { class: "el-upload__tip" }
const _hoisted_82 = { class: "col-md-6" }
const _hoisted_83 = { class: "form-group d-flex flex-wrap" }
const _hoisted_84 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_85 = ["disabled"]
const _hoisted_86 = ["disabled"]
const _hoisted_87 = ["disabled"]
const _hoisted_88 = { class: "el-upload__tip" }
const _hoisted_89 = { class: "col-md-6" }
const _hoisted_90 = { class: "form-group d-flex flex-wrap" }
const _hoisted_91 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_92 = ["disabled"]
const _hoisted_93 = ["disabled"]
const _hoisted_94 = ["disabled"]
const _hoisted_95 = { class: "el-upload__tip" }
const _hoisted_96 = { class: "col-md-6" }
const _hoisted_97 = { class: "form-group d-flex flex-wrap" }
const _hoisted_98 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_99 = ["disabled"]
const _hoisted_100 = ["disabled"]
const _hoisted_101 = ["disabled"]
const _hoisted_102 = { class: "el-upload__tip" }
const _hoisted_103 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1))
const _hoisted_105 = {
  key: 0,
  type: "submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_106 = { class: "indicator-label" }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 size" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "bi bi-sd-card-fill"
  })
], -1))
const _hoisted_108 = { class: "indicator-progress" }
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_110 = { class: "card mb-5 mb-xl-10" }
const _hoisted_111 = { class: "card-header" }
const _hoisted_112 = { class: "card-title m-0" }
const _hoisted_113 = { class: "fw-boldest m-0" }
const _hoisted_114 = { class: "card-body p-9" }
const _hoisted_115 = { style: {"min-height":"100px"} }
const _hoisted_116 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1))
const _hoisted_118 = {
  key: 0,
  type: "submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_119 = { class: "indicator-label" }
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 size" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "bi bi-sd-card-fill"
  })
], -1))
const _hoisted_121 = { class: "indicator-progress" }
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_123 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_124 = { class: "card-header" }
const _hoisted_125 = { class: "card-title m-0" }
const _hoisted_126 = { class: "fw-boldest m-0" }
const _hoisted_127 = { class: "card-body p-9" }
const _hoisted_128 = { class: "row" }
const _hoisted_129 = { class: "col-md-6" }
const _hoisted_130 = { class: "form-group d-flex flex-wrap" }
const _hoisted_131 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_132 = { class: "col-md-6" }
const _hoisted_133 = { class: "form-group d-flex flex-wrap" }
const _hoisted_134 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_135 = { class: "col-md-6" }
const _hoisted_136 = { class: "form-group d-flex flex-wrap" }
const _hoisted_137 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_138 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1))
const _hoisted_140 = {
  key: 0,
  type: "submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_141 = { class: "indicator-label" }
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 size" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "bi bi-sd-card-fill"
  })
], -1))
const _hoisted_143 = { class: "indicator-progress" }
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_permission_common = _resolveComponent("permission-common")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_FsLightbox = _resolveComponent("FsLightbox")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_auth = _resolveDirective("auth")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_form, {
      onSubmit: _cache[36] || (_cache[36] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
      rules: _ctx.rules,
      model: _ctx.formData,
      ref: "formRef"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.t("customDeclarationExport.exportIdentifier")), 1)
            ])
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.t("customDeclarationExport.status")), 1),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["badge", _ctx.statusClass(_ctx.formData.status).statusClass])
                    }, _toDisplayString(_ctx.statusClass(_ctx.formData.status).str), 3)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.t("customDeclarationExport.customsDeclarationNo")), 1),
                  _createVNode(_component_el_form_item, { prop: "declaration_export_no" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.declaration_export_no,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.declaration_export_no) = $event)),
                        type: "text",
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.t("customDeclarationExport.overseasShipment")), 1),
                  _createVNode(_component_el_form_item, { prop: "tracking_no" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.tracking_no,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.tracking_no) = $event)),
                        type: "text",
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.t("customDeclarationExport.exportHandlingCompanyName")), 1),
                  _createVNode(_component_el_form_item, { prop: "export_handling_company" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.export_handling_company,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.export_handling_company) = $event)),
                        clearable: "",
                        style: {"width":"100%"},
                        placeholder: _ctx.t('common.plsSelect')
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.export_handling_company, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.t("customDeclarationExport.carrierName")), 1),
                  _createVNode(_component_el_form_item, { prop: "carrier_name" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.carrier_name,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.carrier_name) = $event)),
                        type: "text",
                        placeholder: _ctx.t('common.plsEnter'),
                        clearable: ""
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.t("customDeclarationExport.awbNumber")), 1),
                  _createVNode(_component_el_form_item, { prop: "awb_number" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.awb_number,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.awb_number) = $event)),
                        type: "text",
                        placeholder: _ctx.t('common.plsEnter'),
                        clearable: ""
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])), [
            [_directive_loading, _ctx.loading]
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary align-self-center me-2",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
            }, [
              _hoisted_27,
              _createTextVNode(" " + _toDisplayString(_ctx.t("common.backToList")), 1)
            ]),
            _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
              default: _withCtx(() => [
                (_ctx.options.defaultFormData.approval_date == '' && !_ctx.loading)
                  ? (_openBlock(), _createElementBlock("button", _hoisted_28, [
                      _createElementVNode("span", _hoisted_29, [
                        _hoisted_30,
                        _createTextVNode(" " + _toDisplayString(_ctx.t("common.saveChanges")), 1)
                      ]),
                      _createElementVNode("span", _hoisted_31, [
                        _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                        _hoisted_32
                      ])
                    ], 512))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("h3", _hoisted_36, _toDisplayString(_ctx.t("customDeclarationExport.exportDeclaration")), 1)
            ])
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.t("customDeclarationExport.declarationDate")), 1),
                  _createVNode(_component_el_form_item, { prop: "declaration_date" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.formData.declaration_date,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.declaration_date) = $event)),
                        type: "date",
                        clearable: "",
                        placeholder: _ctx.t('common.pickDate'),
                        style: {"width":"100%"},
                        onChange: _cache[7] || (_cache[7] = ($event: any) => (
                    _ctx.commonChangeDefaultDate(
                      $event,
                      _ctx.formData,
                      'declaration_date'
                    )
                  ))
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.t("customDeclarationExport.dueDate")), 1),
                  _createVNode(_component_el_form_item, { prop: "due_date" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.formData.due_date,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.due_date) = $event)),
                        type: "date",
                        clearable: "",
                        placeholder: _ctx.t('common.pickDate'),
                        style: {"width":"100%"},
                        onChange: _cache[9] || (_cache[9] = ($event: any) => (
                    _ctx.commonChangeDefaultDate($event, _ctx.formData, 'due_date')
                  ))
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.t("customDeclarationExport.approvalDate")), 1),
                  _createVNode(_component_el_form_item, { prop: "approval_date" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.formData.approval_date,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.approval_date) = $event)),
                        type: "date",
                        clearable: "",
                        placeholder: _ctx.t('common.pickDate'),
                        style: {"width":"100%"},
                        onChange: _cache[11] || (_cache[11] = ($event: any) => (
                    _ctx.commonChangeDefaultDate($event, _ctx.formData, 'approval_date')
                  ))
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("label", _hoisted_50, _toDisplayString(_ctx.t("customDeclarationExport.declarationArea")), 1),
                  _createVNode(_component_el_form_item, { prop: "declaration_area" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.declaration_area,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.declaration_area) = $event)),
                        type: "text",
                        placeholder: _ctx.t('common.plsEnter'),
                        clearable: ""
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.t("customDeclarationExport.customDeclaredValue")), 1),
                  _createVNode(_component_el_form_item, { prop: "total_amount" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_54, [
                        _createVNode(_component_el_input_number, {
                          class: "text-start w-100",
                          modelValue: _ctx.formData.total_amount,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.total_amount) = $event)),
                          precision: 2,
                          step: 0.01,
                          controls: false
                        }, null, 8, ["modelValue", "step"]),
                        _hoisted_55
                      ])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("label", _hoisted_58, _toDisplayString(_ctx.t("customDeclarationExport.totalQuantity")), 1),
                  _createVNode(_component_el_form_item, { prop: "total_quantity" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.total_quantity,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.total_quantity) = $event)),
                        type: "number",
                        placeholder: _ctx.t('common.plsEnter')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("label", _hoisted_61, _toDisplayString(_ctx.t("customDeclarationExport.customsInspection")), 1),
                  _createVNode(_component_el_form_item, { prop: "customs_inspection" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_switch, {
                        modelValue: _ctx.formData.customs_inspection,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.customs_inspection) = $event)),
                        "active-value": 1,
                        "inactive-value": 0
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("label", _hoisted_64, _toDisplayString(_ctx.t("customDeclarationExport.customsInspectionAddress")), 1),
                  _createVNode(_component_el_form_item, { prop: "customs_inspection_address" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.customs_inspection_address,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.customs_inspection_address) = $event)),
                        type: "text",
                        placeholder: _ctx.t('common.plsEnter'),
                        clearable: ""
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_65, [
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("label", _hoisted_67, _toDisplayString(_ctx.t("customDeclarationExport.customsInspectionDate")), 1),
                  _createVNode(_component_el_form_item, { prop: "customs_inspection_dates" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.formData.customs_inspection_dates,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.customs_inspection_dates) = $event)),
                        type: "date",
                        clearable: "",
                        placeholder: _ctx.t('common.pickDate'),
                        style: {"width":"100%"},
                        onChange: _cache[18] || (_cache[18] = ($event: any) => (
                    _ctx.commonChangeDefaultDate(
                      $event,
                      _ctx.formData,
                      'customs_inspection_dates'
                    )
                  ))
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_68, [
                _createElementVNode("div", _hoisted_69, [
                  _createElementVNode("label", _hoisted_70, _toDisplayString(_ctx.t("customDeclarationExport.exportPort")), 1),
                  _createVNode(_component_el_form_item, { prop: "export_port" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.export_port,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formData.export_port) = $event)),
                        clearable: "",
                        placeholder: _ctx.t('common.plsSelect'),
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.export_port, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_71, [
                _createElementVNode("div", _hoisted_72, [
                  _createElementVNode("label", _hoisted_73, _toDisplayString(_ctx.t("customDeclarationExport.mrnNumber")), 1),
                  _createVNode(_component_el_form_item, { prop: "mrn_number" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.mrn_number,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formData.mrn_number) = $event)),
                        type: "text",
                        placeholder: _ctx.t('common.plsEnter'),
                        clearable: ""
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("h3", null, _toDisplayString(_ctx.t("customDeclarationExport.fileUpload")), 1),
              _hoisted_74,
              _createElementVNode("div", _hoisted_75, [
                _createElementVNode("div", _hoisted_76, [
                  _createElementVNode("label", _hoisted_77, _toDisplayString(_ctx.t("customDeclarationExport.abdUpload")), 1),
                  _createVNode(_component_el_form_item, { prop: "abd" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_upload, {
                        ref: "upload-abd",
                        accept: ".pdf",
                        "file-list": _ctx.options.abd,
                        action: _ctx.uploadUrl,
                        data: { id: _ctx.id, field: _ctx.uploadType },
                        headers: _ctx.uploadHeaders,
                        disabled: _ctx.uploadDisabled.abd,
                        limit: 1,
                        "on-progress": 
                    function (e, file, fileList) {
                      return _ctx.handleProgress(e, file, fileList, 'abd');
                    }
                  ,
                        "on-success": 
                    function (response, file, fileList) {
                      return _ctx.handleSuccess(response, file, fileList, 'abd');
                    }
                  ,
                        "on-error": 
                    function (err, file, fileList) {
                      return _ctx.handleError(err, file, fileList, 'abd');
                    }
                  ,
                        "on-remove": 
                    function (file, fileList) {
                      return _ctx.handleRemove(
                        file,
                        fileList,
                        'abd',
                        _ctx.formData,
                        _ctx.options,
                        _ctx.removeFlag
                      );
                    }
                  ,
                        "on-exceed": 
                    function (files, fileList) {
                      return _ctx.handleExceed(files, fileList, 'abd');
                    }
                  ,
                        "before-upload": _ctx.handleBeforeUpload
                      }, {
                        trigger: _withCtx(() => [
                          _withDirectives((_openBlock(), _createElementBlock("button", {
                            type: "button",
                            class: "btn btn-primary btn-sm me-2",
                            onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.setUploadType('abd'))),
                            disabled: _ctx.uploadDisabled.abd
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.$t("customDeclarationExport.fileUpload")), 1)
                          ], 8, _hoisted_78)), [
                            [_directive_auth, { auth: ['update'] }]
                          ])
                        ]),
                        tip: _withCtx(() => [
                          _createElementVNode("div", _hoisted_81, _toDisplayString(_ctx.t("customDeclarationExport.uploadTip")), 1)
                        ]),
                        default: _withCtx(() => [
                          _withDirectives((_openBlock(), _createElementBlock("button", {
                            type: "button",
                            class: "btn btn-danger btn-sm me-2",
                            disabled: _ctx.uploadDisabled.abd || _ctx.formData.abd == 0,
                            onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.handleDeleteUpload('abd', _ctx.formData)))
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.$t("customDeclarationExport.fileDelete")), 1)
                          ], 8, _hoisted_79)), [
                            [_directive_auth, { auth: ['update'] }]
                          ]),
                          _withDirectives((_openBlock(), _createElementBlock("button", {
                            type: "button",
                            class: "btn btn-success btn-sm me-2",
                            disabled: _ctx.uploadDisabled.abd || _ctx.formData.abd == 0,
                            onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.handlePreview('abd')))
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.$t("customDeclarationExport.filePreview")), 1)
                          ], 8, _hoisted_80)), [
                            [_directive_auth, { auth: ['export'] }]
                          ])
                        ]),
                        _: 1
                      }, 8, ["file-list", "action", "data", "headers", "disabled", "on-progress", "on-success", "on-error", "on-remove", "on-exceed", "before-upload"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_82, [
                _createElementVNode("div", _hoisted_83, [
                  _createElementVNode("label", _hoisted_84, _toDisplayString(_ctx.t("customDeclarationExport.avmUpload")), 1),
                  _createVNode(_component_el_form_item, { prop: "avm" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_upload, {
                        ref: "upload-avm",
                        accept: ".pdf",
                        "file-list": _ctx.options.avm,
                        action: _ctx.uploadUrl,
                        data: { id: _ctx.id, field: _ctx.uploadType },
                        headers: _ctx.uploadHeaders,
                        disabled: _ctx.uploadDisabled.avm,
                        limit: 1,
                        "on-progress": 
                    function (e, file, fileList) {
                      return _ctx.handleProgress(e, file, fileList, 'avm');
                    }
                  ,
                        "on-success": 
                    function (response, file, fileList) {
                      return _ctx.handleSuccess(response, file, fileList, 'avm');
                    }
                  ,
                        "on-error": 
                    function (err, file, fileList) {
                      return _ctx.handleError(err, file, fileList, 'avm');
                    }
                  ,
                        "on-remove": 
                    function (file, fileList) {
                      return _ctx.handleRemove(
                        file,
                        fileList,
                        'avm',
                        _ctx.formData,
                        _ctx.options,
                        _ctx.removeFlag
                      );
                    }
                  ,
                        "on-exceed": 
                    function (files, fileList) {
                      return _ctx.handleExceed(files, fileList, 'avm');
                    }
                  ,
                        "before-upload": _ctx.handleBeforeUpload
                      }, {
                        trigger: _withCtx(() => [
                          _withDirectives((_openBlock(), _createElementBlock("button", {
                            type: "button",
                            class: "btn btn-primary btn-sm me-2",
                            onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.setUploadType('avm'))),
                            disabled: _ctx.uploadDisabled.avm
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.$t("customDeclarationExport.fileUpload")), 1)
                          ], 8, _hoisted_85)), [
                            [_directive_auth, { auth: ['update'] }]
                          ])
                        ]),
                        tip: _withCtx(() => [
                          _createElementVNode("div", _hoisted_88, _toDisplayString(_ctx.t("customDeclarationExport.uploadTip")), 1)
                        ]),
                        default: _withCtx(() => [
                          _withDirectives((_openBlock(), _createElementBlock("button", {
                            type: "button",
                            class: "btn btn-danger btn-sm me-2",
                            disabled: _ctx.uploadDisabled.avm || _ctx.formData.avm == 0,
                            onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.handleDeleteUpload('avm', _ctx.formData)))
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.$t("customDeclarationExport.fileDelete")), 1)
                          ], 8, _hoisted_86)), [
                            [_directive_auth, { auth: ['update'] }]
                          ]),
                          _withDirectives((_openBlock(), _createElementBlock("button", {
                            type: "button",
                            class: "btn btn-success btn-sm me-2",
                            disabled: _ctx.uploadDisabled.avm || _ctx.formData.avm == 0,
                            onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.handlePreview('avm')))
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.$t("customDeclarationExport.filePreview")), 1)
                          ], 8, _hoisted_87)), [
                            [_directive_auth, { auth: ['export'] }]
                          ])
                        ]),
                        _: 1
                      }, 8, ["file-list", "action", "data", "headers", "disabled", "on-progress", "on-success", "on-error", "on-remove", "on-exceed", "before-upload"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_89, [
                _createElementVNode("div", _hoisted_90, [
                  _createElementVNode("label", _hoisted_91, _toDisplayString(_ctx.t("customDeclarationExport.proformaInvoiceUpload")), 1),
                  _createVNode(_component_el_form_item, { prop: "proforma_invoice" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_upload, {
                        ref: "upload-proforma_invoice",
                        accept: ".pdf",
                        "file-list": _ctx.options.proforma_invoice,
                        action: _ctx.uploadUrl,
                        data: { id: _ctx.id, field: _ctx.uploadType },
                        headers: _ctx.uploadHeaders,
                        disabled: _ctx.uploadDisabled.proforma_invoice,
                        limit: 1,
                        "on-progress": 
                    function (e, file, fileList) {
                      return _ctx.handleProgress(
                        e,
                        file,
                        fileList,
                        'proforma_invoice'
                      );
                    }
                  ,
                        "on-success": 
                    function (response, file, fileList) {
                      return _ctx.handleSuccess(
                        response,
                        file,
                        fileList,
                        'proforma_invoice'
                      );
                    }
                  ,
                        "on-error": 
                    function (err, file, fileList) {
                      return _ctx.handleError(
                        err,
                        file,
                        fileList,
                        'proforma_invoice'
                      );
                    }
                  ,
                        "on-remove": 
                    function (file, fileList) {
                      return _ctx.handleRemove(
                        file,
                        fileList,
                        'proforma_invoice',
                        _ctx.formData,
                        _ctx.options,
                        _ctx.removeFlag
                      );
                    }
                  ,
                        "on-exceed": 
                    function (files, fileList) {
                      return _ctx.handleExceed(files, fileList, 'proforma_invoice');
                    }
                  ,
                        "before-upload": _ctx.handleBeforeUpload
                      }, {
                        trigger: _withCtx(() => [
                          _withDirectives((_openBlock(), _createElementBlock("button", {
                            type: "button",
                            class: "btn btn-primary btn-sm me-2",
                            onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.setUploadType('proforma_invoice'))),
                            disabled: _ctx.uploadDisabled.proforma_invoice
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.$t("customDeclarationExport.fileUpload")), 1)
                          ], 8, _hoisted_92)), [
                            [_directive_auth, { auth: ['update'] }]
                          ])
                        ]),
                        tip: _withCtx(() => [
                          _createElementVNode("div", _hoisted_95, _toDisplayString(_ctx.t("customDeclarationExport.uploadTip")), 1)
                        ]),
                        default: _withCtx(() => [
                          _withDirectives((_openBlock(), _createElementBlock("button", {
                            type: "button",
                            class: "btn btn-danger btn-sm me-2",
                            disabled: 
                      _ctx.uploadDisabled.proforma_invoice ||
                      _ctx.formData.proforma_invoice == 0
                    ,
                            onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.handleDeleteUpload('proforma_invoice', _ctx.formData)))
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.$t("customDeclarationExport.fileDelete")), 1)
                          ], 8, _hoisted_93)), [
                            [_directive_auth, { auth: ['update'] }]
                          ]),
                          _withDirectives((_openBlock(), _createElementBlock("button", {
                            type: "button",
                            class: "btn btn-success btn-sm me-2",
                            disabled: 
                      _ctx.uploadDisabled.proforma_invoice ||
                      _ctx.formData.proforma_invoice == 0
                    ,
                            onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.handlePreview('proforma_invoice')))
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.$t("customDeclarationExport.filePreview")), 1)
                          ], 8, _hoisted_94)), [
                            [_directive_auth, { auth: ['export'] }]
                          ])
                        ]),
                        _: 1
                      }, 8, ["file-list", "action", "data", "headers", "disabled", "on-progress", "on-success", "on-error", "on-remove", "on-exceed", "before-upload"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_96, [
                _createElementVNode("div", _hoisted_97, [
                  _createElementVNode("label", _hoisted_98, _toDisplayString(_ctx.t("customDeclarationExport.packingListUpload")), 1),
                  _createVNode(_component_el_form_item, { prop: "packing_list" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_upload, {
                        ref: "upload-packing_list",
                        accept: ".xls,.xlsx",
                        "file-list": _ctx.options.packing_list,
                        action: _ctx.uploadUrl,
                        data: { id: _ctx.id, field: _ctx.uploadType },
                        headers: _ctx.uploadHeaders,
                        disabled: _ctx.uploadDisabled.packing_list,
                        limit: 1,
                        "on-progress": 
                    function (e, file, fileList) {
                      return _ctx.handleProgress(e, file, fileList, 'packing_list');
                    }
                  ,
                        "on-success": 
                    function (response, file, fileList) {
                      return _ctx.handleSuccess(
                        response,
                        file,
                        fileList,
                        'packing_list'
                      );
                    }
                  ,
                        "on-error": 
                    function (err, file, fileList) {
                      return _ctx.handleError(err, file, fileList, 'packing_list');
                    }
                  ,
                        "on-remove": 
                    function (file, fileList) {
                      return _ctx.handleRemove(
                        file,
                        fileList,
                        'packing_list',
                        _ctx.formData,
                        _ctx.options,
                        _ctx.removeFlag
                      );
                    }
                  ,
                        "on-exceed": 
                    function (files, fileList) {
                      return _ctx.handleExceed(files, fileList, 'packing_list');
                    }
                  ,
                        "before-upload": _ctx.handleBeforeUpload
                      }, {
                        trigger: _withCtx(() => [
                          _withDirectives((_openBlock(), _createElementBlock("button", {
                            type: "button",
                            class: "btn btn-primary btn-sm me-2",
                            onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.setUploadType('packing_list'))),
                            disabled: _ctx.uploadDisabled.packing_list
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.$t("customDeclarationExport.fileUpload")), 1)
                          ], 8, _hoisted_99)), [
                            [_directive_auth, { auth: ['update'] }]
                          ])
                        ]),
                        tip: _withCtx(() => [
                          _createElementVNode("div", _hoisted_102, _toDisplayString(_ctx.t("customDeclarationExport.uploadTip")), 1)
                        ]),
                        default: _withCtx(() => [
                          _withDirectives((_openBlock(), _createElementBlock("button", {
                            type: "button",
                            class: "btn btn-danger btn-sm me-2",
                            disabled: 
                      _ctx.uploadDisabled.packing_list || _ctx.formData.packing_list == 0
                    ,
                            onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.handleDeleteUpload('packing_list', _ctx.formData)))
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.$t("customDeclarationExport.fileDelete")), 1)
                          ], 8, _hoisted_100)), [
                            [_directive_auth, { auth: ['update'] }]
                          ]),
                          _withDirectives((_openBlock(), _createElementBlock("button", {
                            type: "button",
                            class: "btn btn-success btn-sm me-2",
                            disabled: 
                      _ctx.uploadDisabled.packing_list || _ctx.formData.packing_list == 0
                    ,
                            onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.handlePreview('packing_list')))
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.$t("customDeclarationExport.fileDownload")), 1)
                          ], 8, _hoisted_101)), [
                            [_directive_auth, { auth: ['export'] }]
                          ])
                        ]),
                        _: 1
                      }, 8, ["file-list", "action", "data", "headers", "disabled", "on-progress", "on-success", "on-error", "on-remove", "on-exceed", "before-upload"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])), [
            [_directive_loading, _ctx.loading]
          ]),
          _createElementVNode("div", _hoisted_103, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary align-self-center me-2",
              onClick: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
            }, [
              _hoisted_104,
              _createTextVNode(" " + _toDisplayString(_ctx.t("common.backToList")), 1)
            ]),
            _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
              default: _withCtx(() => [
                (_ctx.options.defaultFormData.approval_date == '' && !_ctx.loading)
                  ? (_openBlock(), _createElementBlock("button", _hoisted_105, [
                      _createElementVNode("span", _hoisted_106, [
                        _hoisted_107,
                        _createTextVNode(" " + _toDisplayString(_ctx.t("common.saveChanges")), 1)
                      ]),
                      _createElementVNode("span", _hoisted_108, [
                        _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                        _hoisted_109
                      ])
                    ], 512))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_110, [
          _createElementVNode("div", _hoisted_111, [
            _createElementVNode("div", _hoisted_112, [
              _createElementVNode("h3", _hoisted_113, _toDisplayString(_ctx.t("customDeclarationExport.exportItems")), 1)
            ])
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_114, [
            _createVNode(_component_el_table, {
              data: _ctx.itemTable,
              style: {"width":"100%"},
              size: "small",
              "min-width": "220"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "sku_identifier",
                  label: _ctx.t('order.itemIdentifierGtin'),
                  width: "140"
                }, null, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  label: _ctx.t('order.image'),
                  width: "150"
                }, {
                  default: _withCtx(({ row }) => [
                    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_115, [
                      (_ctx.getProductIdData(row.sku_identifier)?.gallery)
                        ? (_openBlock(), _createBlock(_component_el_carousel, {
                            key: 0,
                            "indicator-position": "none",
                            height: "100px",
                            autoplay: false,
                            arrow: "never"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getProductIdData(row.sku_identifier)
                      ?.gallery, (item, index) => {
                                return (_openBlock(), _createBlock(_component_el_carousel_item, {
                                  key: index,
                                  class: "d-flex justify-content-center align-items-center"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_image, {
                                      style: {"width":"100px","height":"100px","cursor":"pointer"},
                                      src: 
                        item.origin_url + '?x-oss-process=image/resize,l_200'
                      ,
                                      fit: "contain",
                                      onClick: ($event: any) => (
                        _ctx.previewImages(
                          _ctx.getProductIdData(row.sku_identifier)?.gallery,
                          index
                        )
                      )
                                    }, null, 8, ["src", "onClick"])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true)
                    ])), [
                      [_directive_loading, _ctx.options.loadingProducts]
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  label: _ctx.t('order.articleInformation'),
                  width: "220"
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("p", null, _toDisplayString(_ctx.getProductIdData(row.sku_identifier)?.name_en), 1),
                    _createElementVNode("p", null, _toDisplayString(_ctx.getProductIdData(row.sku_identifier)?.name), 1),
                    _createElementVNode("p", null, _toDisplayString(_ctx.getProductIdData(row.sku_identifier)?.__show.brand_id), 1),
                    _createElementVNode("p", null, _toDisplayString(_ctx.getProductIdData(row.sku_identifier)?.brand_article_no), 1),
                    _createElementVNode("p", null, _toDisplayString(_ctx.getProductIdData(row.sku_identifier)?.merchant_article_no), 1)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  label: _ctx.t('order.articleAttributes'),
                  width: "220"
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("p", null, _toDisplayString(_ctx.t("order.size")) + ": " + _toDisplayString(_ctx.getProductIdData(row.sku_identifier)?.__show.size), 1),
                    _createElementVNode("p", null, _toDisplayString(_ctx.t("order.color")) + ": " + _toDisplayString(_ctx.getProductIdData(row.sku_identifier)?.original_color), 1),
                    _createElementVNode("p", null, _toDisplayString(_ctx.t("order.netWeight")) + ": " + _toDisplayString(_ctx.getProductIdData(row.sku_identifier)?.net_weight), 1),
                    _createElementVNode("p", null, _toDisplayString(_ctx.t("order.grossWeight")) + ": " + _toDisplayString(_ctx.getProductIdData(row.sku_identifier)?.weight), 1)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  label: _ctx.t('order.package')
                }, {
                  default: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(_ctx.getProductIdData(row.sku_identifier)?.package_material), 1)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  label: _ctx.t('order.eanNumber')
                }, {
                  default: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(_ctx.getProductIdData(row.sku_identifier)?.gtin), 1)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  label: _ctx.t('order.hsCodeOfDe')
                }, null, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  label: _ctx.t('order.hsCodeOfCn')
                }, null, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  label: _ctx.t('order.cde')
                }, null, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  label: _ctx.t('order.productType')
                }, null, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  label: _ctx.t('order.productCategory')
                }, null, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  label: _ctx.t('order.countyOfOriginCo')
                }, {
                  default: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(_ctx.getProductIdData(row.sku_identifier)?.country_of_origin), 1)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  label: _ctx.t('order.quantity'),
                  prop: "quantity",
                  align: "right"
                }, null, 8, ["label"])
              ]),
              _: 1
            }, 8, ["data"])
          ])), [
            [_directive_loading, _ctx.loading]
          ]),
          _createElementVNode("div", _hoisted_116, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary align-self-center me-2",
              onClick: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
            }, [
              _hoisted_117,
              _createTextVNode(" " + _toDisplayString(_ctx.t("common.backToList")), 1)
            ]),
            _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
              default: _withCtx(() => [
                (_ctx.options.defaultFormData.approval_date == '' && !_ctx.loading)
                  ? (_openBlock(), _createElementBlock("button", _hoisted_118, [
                      _createElementVNode("span", _hoisted_119, [
                        _hoisted_120,
                        _createTextVNode(" " + _toDisplayString(_ctx.t("common.saveChanges")), 1)
                      ]),
                      _createElementVNode("span", _hoisted_121, [
                        _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                        _hoisted_122
                      ])
                    ], 512))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ]),
        (0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
              _createElementVNode("div", _hoisted_124, [
                _createElementVNode("div", _hoisted_125, [
                  _createElementVNode("h3", _hoisted_126, _toDisplayString(_ctx.t("customDeclarationExport.exportDeclarationLog")), 1)
                ])
              ]),
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_127, [
                _createElementVNode("div", _hoisted_128, [
                  _createElementVNode("div", _hoisted_129, [
                    _createElementVNode("div", _hoisted_130, [
                      _createElementVNode("label", _hoisted_131, _toDisplayString(_ctx.t("customDeclarationExport.dateTime")), 1),
                      _createVNode(_component_el_form_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            type: "date",
                            style: {"width":"100%"},
                            disabled: ""
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_132, [
                    _createElementVNode("div", _hoisted_133, [
                      _createElementVNode("label", _hoisted_134, _toDisplayString(_ctx.t("customDeclarationExport.logType")), 1),
                      _createVNode(_component_el_form_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            clearable: "",
                            style: {"width":"100%"},
                            disabled: ""
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.log_type, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_135, [
                    _createElementVNode("div", _hoisted_136, [
                      _createElementVNode("label", _hoisted_137, _toDisplayString(_ctx.t("customDeclarationExport.logDescription")), 1),
                      _createVNode(_component_el_form_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            type: "text",
                            disabled: ""
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])), [
                [_directive_loading, _ctx.loading]
              ]),
              _createElementVNode("div", _hoisted_138, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary align-self-center me-2",
                  onClick: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
                }, [
                  _hoisted_139,
                  _createTextVNode(" " + _toDisplayString(_ctx.t("common.backToList")), 1)
                ]),
                _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
                  default: _withCtx(() => [
                    (_ctx.options.defaultFormData.approval_date == '' && !_ctx.loading)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_140, [
                          _createElementVNode("span", _hoisted_141, [
                            _hoisted_142,
                            _createTextVNode(" " + _toDisplayString(_ctx.t("common.saveChanges")), 1)
                          ]),
                          _createElementVNode("span", _hoisted_143, [
                            _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                            _hoisted_144
                          ])
                        ], 512))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["rules", "model"]),
    _createVNode(_component_FsLightbox, {
      toggler: _ctx.options.toggler,
      sources: _ctx.options.sources,
      slide: _ctx.options.sourcesSlide
    }, null, 8, ["toggler", "sources", "slide"])
  ], 64))
}